import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpInterceptor } from '@angular/common/http'
import { throwError, Observable } from 'rxjs'
import { catchError, flatMap } from 'rxjs/operators'
import { NGXLogger } from 'ngx-logger'
import { ACCOUNT_AUTH_GROUP } from '../../modules/account/account-api'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { UserProps } from '../../modules/account/services/api/additional/UserProps'
import { LoginService } from '../../modules/account/services/api/login.service'


@Injectable()
export class LoginAuthInterceptorExtension implements HttpInterceptor {
  constructor(
    public logger: NGXLogger,
    public loginService: LoginService,
    private modalStateService: ModalStateService,
    ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {

    // console.log('using login token')
    const userProps = this.modalStateService.getFromLocalStorageProps(new UserProps())
    const phase2Token = userProps.userSessionToken
    if (phase2Token) {
      request = this.attachToken(request, phase2Token)
    }

    return this.renewTokenOnError(next, request)

  }

  private renewTokenOnError(next, request) {
    return next.handle(request).pipe(
      catchError((err) => {

        // console.log(err.message)
        if (err.status === 401 || err.status === 403
          ) {

          // console.log('refresh login token')
          if (true) {
            // clear tokens and go to login
            // without logout request
            this.loginService.clearAndProceedLogin()
            return next.handle(request)
          }
          // this.loginService.refreshLogin()
          // .subscribe(res => {
          //   const props = this.modalStateService.getFromLocalStorageClass(new UserProps())
          //   const isLogout = this.modalStateService.getFromLocalStorage('isLogout')
          //   if (!isLogout) {
          //     // tslint:disable-next-line: tsr-detect-possible-timing-attacks
          //     request = props?.userSessionToken !== undefined
          //             ? this.attachToken(request, props.userSessionToken)
          //             : this.attachRefreshToken(request, props.userRefreshToken)
          //   }
          //   return next.handle(request)
          // })
        }
        return throwError(err)
      })
    )
  }


  private attachToken(request: HttpRequest<any>, accessToken) {
    if (request.url.search(ACCOUNT_AUTH_GROUP.POST_USER_LOGIN) === -1) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
    }
    return request
  }

  private attachRefreshToken(request: HttpRequest<any>, refreshToken) {
    if (request.url.search(ACCOUNT_AUTH_GROUP.POST_USER_LOGIN) === -1) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${refreshToken}`,
        },
      })
    }
    return request
  }
}
